import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper} from "../../helpers";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImplementationControlStatement} from "../../_models/implementationControlStatement";
import {DictionaryService} from "../../_services/dictionary.service";

@Component({
  standalone: false,
  selector: "select-dictionary-item",
  templateUrl: 'select-dictionary-item.component.html',
  styleUrls: ['./select-dictionary-item.component.scss'],
})
export class SelectDictionaryItemComponent implements OnInit {
  implementationControlStatementSets: ImplementationControlStatement[] = [];
  currentUser: User;
  dictionaryItems: any[];
  dictionary: string;
  rowGroupMetadata: any = {};
  group: string = '';

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dictionaryService: DictionaryService,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectDictionaryItemComponent>) {
    this.dictionary = data.dictionary;
    this.group = data.group;
  }

  ngOnInit() {
    this.dictionaryService.get([this.dictionary]).subscribe(d => {
      this.dictionaryItems = d;
      if (this.group) {
        this.updateRowGroupMetaData();
      }
    });
  }

  selectImplementationControlStatement(data) {
    this.dialogRef.close(data);
  }

  addToken(html) {
    console.log(html);
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = this.rowGroupMetadata || {};
    if (this.dictionaryItems) {
      for (let i = 0; i < this.dictionaryItems.length; i++) {
        let rowData = this.dictionaryItems[i];
        let brand = rowData[this.group];
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = this.dictionaryItems[i - 1];
          let previousRowGroup = previousRowData[this.group];
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[brand].size++;
          } else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }
}
